import { render, staticRenderFns } from "./ForumAdminV.vue?vue&type=template&id=217f83e7"
import script from "./ForumAdminV.vue?vue&type=script&lang=js"
export * from "./ForumAdminV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports